import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-4 flex flex-col h-screen w-full overflow-hidden" }
const _hoisted_2 = { class: "bg-white flex flex-col text-12px xxl:text-14px text-black-lp-300 rounded-xl px-4 h-full pt-4 mt-4" }
const _hoisted_3 = { class: "flex gap-x-6 text-xl border-b border-gray-lp-400" }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { class: 
                `pb-4 px-4 font-semibold hover:text-red-lp-100 focus:outline-none text-red-lp-100 border-b-2 border-red-lp-100`
               }
const _hoisted_6 = { class: "overflow-y-auto pb-6 px-4" }
const _hoisted_7 = { class: "text-16px font-bold text-black-lp-300 mb-2" }
const _hoisted_8 = {
  key: 0,
  class: "border-b border-gray-lp-900 my-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("button", _hoisted_5, _toDisplayString(_ctx.$t("cargo.v2.detail.tab.history")), 1)
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        (_ctx.historyData.length === 0)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 0,
              customMessage: _ctx.$t('cargo.v2.history.empty.noData'),
              "data-testid": "cargo-v2-history-empty-state"
            }, null, 8, ["customMessage"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.historyData, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: item.date
          }, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.formatDate(item.date)), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.items, (historyItem, historyIndex) => {
              return (_openBlock(), _createBlock(_component_Timeline, {
                key: historyItem.date+historyItem.status,
                item: historyItem,
                dateTime: historyItem.date,
                active: historyItem.active,
                status: historyItem.status,
                transitLocation: historyItem.transitLocation,
                districtCity: historyItem.districtCity,
                description: historyItem.description,
                tooltip: historyItem.description,
                koli: historyItem.koli,
                grossWeight: historyItem.grossWeight,
                volumeWeight: historyItem.volumeWeight,
                flightCode: historyItem.flightCode,
                flightDateTime: _ctx.flightDateTime(historyItem),
                isVerticalLine: historyIndex < item.items?.length - 1,
                isHalfVerticalLine: 
              historyIndex === item.items?.length - 1 &&
                index < _ctx.historyData?.length - 1
            ,
                departureFlightDate: historyItem.departureFlightDate,
                arrivalFlightDate: historyItem.arrivalFlightDate,
                totalTransit: historyItem.totalTransit,
                cargoFlightDetails: historyItem.cargoFlightDetails
              }, null, 8, ["item", "dateTime", "active", "status", "transitLocation", "districtCity", "description", "tooltip", "koli", "grossWeight", "volumeWeight", "flightCode", "flightDateTime", "isVerticalLine", "isHalfVerticalLine", "departureFlightDate", "arrivalFlightDate", "totalTransit", "cargoFlightDetails"]))
            }), 128)),
            (index < _ctx.historyData?.length - 1)
              ? (_openBlock(), _createBlock("div", _hoisted_8))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}